import gql from "graphql-tag";
import {
  TemplateDetail_template,
  TemplateDetail as TemplateDetail_t
} from "@/models/queries/types/TemplateDetail";

export const TEMPLATE_DETAIL_QUERY = gql`
  query TemplateDetail($templateId: ID!) {
    template(templateId: $templateId) {
      id
      name
      characteristics {
        id
        shortcut
        unit {
          id
          name
        }
        category
        dataType
        translations {
          de
          en
          zh
        }
        localizedKey
        order
      }
    }
  }
`;

export type TemplateDetail = TemplateDetail_template;
export type TemplateDetailResult = TemplateDetail_t;
